import {
  WSFlexBox,
  WSLabel,
  WSText,
  WSModal,
  useWSModalCustom,
  WSElement
} from "@wingspanhq/fe-component-library";
import { useHistory } from "react-router-dom";
import { getCreateRequirementDefinitionFlowPathname } from "../../paths/helpers";
import { RequirementDefinitionTemplate } from "../../routes/RouteCreateRequirementByTemplate/types";

const ModalLearnMoreRequirementTemplate: React.FC<{
  template: RequirementDefinitionTemplate;
  onClose: () => void;
}> = ({ onClose, template }) => {
  const history = useHistory();

  return (
    <WSModal
      title={template.name ?? "Learn more"}
      onClose={onClose}
      size="S"
      actions={{
        alignment: "fill",
        buttons: [
          {
            label: "Close",
            onClick: onClose,
            kind: "Tertiary"
          },
          {
            label: "Select",
            onClick: () => {
              history.push(
                getCreateRequirementDefinitionFlowPathname(template.key)
              );
            },
            kind: "Primary"
          }
        ]
      }}
    >
      <WSFlexBox direction="column" gap="L">
        <WSElement>
          <WSLabel text="Description" />
          <WSText.ParagraphSm weight="book" color="gray600">
            {template.modal.description}
          </WSText.ParagraphSm>
        </WSElement>

        <WSElement>
          <WSLabel text="Example use cases" />
          <WSText.ParagraphSm weight="book" color="gray600">
            {template.modal.exampleUseCases}
          </WSText.ParagraphSm>
        </WSElement>

        <WSElement>
          <WSLabel text="Cost" />
          <WSText.ParagraphSm weight="book" color="gray600">
            {template.modal.cost}
          </WSText.ParagraphSm>
        </WSElement>
      </WSFlexBox>
    </WSModal>
  );
};

export const useLearnMoreRequirementTemplateModal = () =>
  useWSModalCustom(ModalLearnMoreRequirementTemplate);
